<script lang="ts">
    import { page } from '$app/stores';
    import { MARKET_SLUGS } from '$src/lib/services/market/slugs';
    const { slug } = $page.data.market;
    const tld = slug == MARKET_SLUGS.ES ? 'es' : 'com';
    const href = `https://www.casumo.${tld}/images/favicon.png`;
</script>

<svelte:head>
    <link data-rh="true" rel="icon" {href} type="image/x-icon" />
</svelte:head>
